<template>
    <div>
        <div v-if="configType === 'llm_analysis'" class="mb-2">
            {{ $f.tc('analysisDescription') }}
        </div>
        <v-form v-model="formValid" @submit="submit" ref="form">
            <div style="margin-top: 5px; position: relative"
                 v-for="(item, index) in configList" :key="index">
                <div v-if="item" class="mb-2 config">
                    <div style="width: 100%">
                        <div class="config-header mb-3">
                            <div v-if="isEdit" style="position: absolute; top:0; right:0">
                                <v-btn small icon @click="deleteConfig(index) ">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <div v-if="configType !== 'llm_summary'" class="centerY">
                            <div style="width: 90% !important;">
                                <div class="centerY">
                                    <div class="label mt-0">{{ $f.tc('label') }}</div>
                                    <img v-show="item.error" src="/img/warning.svg"
                                         alt="icon-warning-validate-voice-profile"
                                         style="width: 20px"
                                         class="ml-2 mb-6"
                                    >
                                </div>
                                <v-text-field
                                    outlined
                                    v-model="item.label"
                                    class="input-custom"
                                    :rules="[formRules.ruleRequired, ruleDuplicateLabel]"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </div>
                            <div class="ml-10"
                                 style="flex: 1;display: flex; align-items: center; cursor: pointer;"
                                 @click="toggleShowConfig(item)">
                                <img src="/img/arrow-down.svg" alt="icon-expand-config"
                                     style="width: 20px; transition: 0.3s"
                                     :style="item.isShow ? {transform: `rotate(180deg)`} : ''">
                            </div>
                        </div>
                    </div>
                    <v-expand-transition>
                        <div v-if="item.isShow" class="mt-2"
                             :class="configType !== 'llm_summary' ? 'config' : ''">
                            <div class="centerY p-10">
                                <div class="label" style="margin-bottom: 0 !important;">{{
                                        $f.tc('llmConfig')
                                    }}
                                </div>
                                <v-select
                                    outlined
                                    v-model="item.llm_config"
                                    :items="allowedLlmConfigs"
                                    class="input-custom pl-12"
                                    :readonly="!isEdit"
                                    item-value="id"
                                    item-text="model"
                                    :rules="[formRules.ruleRequired]"
                                    :placeholder="$f.tc('select')+'...'"
                                ></v-select>
                            </div>
                            <div class="label"
                                 style="margin-bottom: 0 !important; padding: 10px">{{ $f.tc('systemPrompt') }}
                            </div>
                            <v-textarea
                                outlined
                                type="string"
                                v-model="item.parameters.system_prompt"
                                class="textarea-custom"
                                :readonly="!isEdit"
                                style="margin-top: 6px !important;padding: 10px"
                                :rules="[formRules.ruleRequired]"
                            ></v-textarea>
                            <div v-if="configType==='llm_summary'" class="centerY p-10">
                                <div class="btn-custom"
                                     @click="insertDefaultSummaryPrompt">
                                    {{ $f.tc('insertPromptTemplate') }}
                                </div>
                            </div>
                            <div class="centerY p-10">
                                <div class="label" style="margin-bottom: 0 !important; width: 15%">{{
                                        $f.tc('temperature')
                                    }}
                                </div>
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="item.parameters.temperature"
                                    :min="0"
                                    :max="1"
                                    step="0.001"
                                    @focusout="validateTemperature(index)"
                                    class="input-custom input-number"
                                    style="max-width: 120px; margin-top: 0 !important; padding-top: 0 !important;"
                                    :readonly="!isEdit"
                                    :rules="[formRules.ruleRequired]"
                                ></v-text-field>
                            </div>
                            <div class="centerY p-10">
                                <div class="label" style="margin-bottom: 0 !important; width: 15%">{{
                                        $f.tc('topP')
                                    }}
                                </div>
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="item.parameters.top_p"
                                    :min="0"
                                    :max="1"
                                    step="0.001"
                                    @focusout="validateTopP(index)"
                                    class="input-custom input-number"
                                    style="max-width: 120px; margin-top: 0 !important; padding-top: 0 !important;"
                                    :readonly="!isEdit"
                                    :rules="[formRules.ruleRequired]"
                                ></v-text-field>
                            </div>
                            <div class="centerY p-10">
                                <div class="label" style="margin-bottom: 0 !important; width: 15%">{{
                                        $f.tc('maxTokens')
                                    }}
                                </div>
                                <v-text-field
                                    outlined
                                    type="number"
                                    v-model="item.parameters.max_tokens"
                                    :min="0"
                                    :max="4096"
                                    step="1"
                                    @focusout="validateTokens(index)"
                                    class="input-custom input-number"
                                    style="max-width: 120px; margin-top: 0 !important; padding-top: 0 !important;"
                                    :readonly="!isEdit"
                                    :rules="[formRules.ruleRequired]"
                                ></v-text-field>
                            </div>
                            <div class="centerY p-10" style="height: 52px">
                                <div style="max-width: 30px">
                                    <v-checkbox
                                        hide-details
                                        color="#0052CC"
                                        v-model="item.parameters.include_chat_history"
                                        :readonly="!isEdit"
                                    ></v-checkbox>
                                </div>
                                <div class="label mr-2" style="margin-bottom: 0 !important">{{
                                        $f.tc('includeChatHistory')
                                    }}
                                </div>
                                <v-text-field
                                    v-if="item.parameters.include_chat_history"
                                    outlined
                                    type="number"
                                    v-model="item.parameters.turns"
                                    :min="1"
                                    :max="10"
                                    step="1"
                                    @focusout="validateTurns(index)"
                                    class="input-custom input-number mr-2"
                                    style="max-width: 60px; margin-top: 0 !important; padding-top: 0 !important;"
                                    :readonly="!isEdit"
                                ></v-text-field>
                                <div v-if="item.parameters.include_chat_history" class="label"
                                     style="margin-bottom: 0 !important">{{
                                        $tc('lastTurns')
                                    }}
                                </div>
                            </div>
                        </div>
                    </v-expand-transition>
                </div>
            </div>
        </v-form>
        <div v-if="isEdit && !(configType === 'llm_summary' && configList.length > 0)"
             class="centerY justify-start mt-6">
            <div class="btn-outline" @click="addConfig">
                <img src="/img/add-blue.svg" alt="icon-add-interrupt-config"
                     style="margin-right: 6px; transform: scale(1.1) ">
                {{ $f.tc('addNew') }}
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

const configDefault = {
    "label": "",
    "llm_config": "",
    "parameters": {
        "system_prompt": "",
        "temperature": "0",
        "top_p": "1",
        "max_tokens": "512",
        "include_chat_history": false,
        "turns": ""
    },
    "error": false,
    "isShow": true
}

const defaultSummaryPrompt = "You are an advanced language model tasked with summarizing call conversations between Bot and customers. Given a transcript of a call conversation, your job is to provide a concise summary that captures the main points and key outcomes of this interaction. Use a maximum of 3 sentences. Answer in Vietnamese."

import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin.vue";
import FormMixin from "@/modules/fptai/mixins/FormMixin.vue";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "LLMConfig",
    mixins: [DialogPromiseMixin, FormMixin],
    props: {
        config: {
            type: Array,
            default: () => []
        },
        allowedLlmConfigs: {
            type: Array,
            default: () => []
        },
        configType: {
            type: String,
            default: () => ""
        },
    },
    computed: {
        ...mapState({
            treeData: state => state.scenario.treeData,
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        originalItemMap() {
            let map = {}
            let lst = this.config.filter(item => item.type)
            for (let item of lst) {
                map[item.id] = item
            }
            return map
        },
        isInsight() {
            return this.configType === 'llm_summary' || this.configType === 'llm_analysis'
        },
        configTypeText() {
            let item = ""
            switch (this.configType) {
                case 'llm_classifier':
                    item = this.$t('llmClassifier')
                    break;
                case 'llm_response':
                    item = this.$t('llmResponse')
                    break;
                case 'llm_summary':
                    item = this.$t('llmSummary')
                    break;
                case 'llm_analysis':
                    item = this.$t('llmAnalysis')
                    break;
                default:
            }
            return item
        },
        nodeUsedConfigs() {
            let result = []
            let nodeList = []
            if (this.treeData) {
                nodeList = this.treeData.nodeList
            }
            switch (this.configType) {
                case 'llm_classifier':
                    result = nodeList.length === 0 ? [] : nodeList.filter(node => node.config.llmClassifier && node.config.llmClassifier.length > 0)
                    break;
                case 'llm_response':
                    result = nodeList.filter(node => {
                        if (node.config.llmResponse && Object.keys(node.config.llmResponse).length > 0) {
                            return true
                        }
                        if (node.config.rePromptList && node.config.rePromptList.length > 0) {
                            let rePromptCheck = node.config.rePromptList.filter(item => item.llmResponse && Object.keys(item.llmResponse).length > 0)
                            if (rePromptCheck.length > 0) {
                                return true
                            }
                        }
                        return false
                    })
                    break;
                default:
                    result = []
                    break;
            }
            return result
        }
    },
    data() {
        return {
            configList: []
        }
    },
    methods: {
        loadData() {
            let arr = []
            for (let obj of this.config) {
                let temp = this.$utils.cloneObject(obj)
                temp.error = false
                if (!temp.isShow) {
                    temp.isShow = false
                }
                if (temp.type === 'llm_summary') {
                    temp.isShow = true
                }
                if (!temp.parameters.turns) {
                    temp.parameters.turns = ""
                }
                if (!temp.oldLabel) {
                    temp.oldLabel = temp.label
                }
                delete temp.parameters.prompt
                arr.push(temp)
            }
            this.configList = arr
        },
        addConfig() {
            if (this.allowedLlmConfigs.length === 0) {
                this.$appService.toastError(this.$f.tc('noLLMConfigs'))
                return
            }
            let temp = this.$utils.cloneObject(configDefault)
            temp['type'] = this.configType
            if (this.configType === 'llm_summary') {
                temp.label = 'summary'
                temp.parameters.system_prompt = defaultSummaryPrompt
            }
            if (this.isInsight) {
                temp.parameters.include_chat_history = true
            }
            this.configList.push(temp)
        },
        deleteConfig(index) {
            if (!this.checkValidDelete(index)) {
                return
            }
            this.configList.splice(index, 1)
        },
        toggleShowConfig(item) {
            item.isShow = !item.isShow
        },
        validateTemperature(index) {
            let temp = String(this.configList[index].parameters.temperature)
            let num = parseFloat(temp.substring(0, 5))
            if (isNaN(num)) {
                this.configList[index].parameters.temperature = 0
                return
            }
            if (num < 0 || num > 1) {
                num = 0
            }
            this.configList[index].parameters.temperature = String(num)
        },
        validateTopP(index) {
            let temp = String(this.configList[index].parameters.top_p)
            let num = parseFloat(temp.substring(0, 5))
            if (isNaN(num)) {
                this.configList[index].parameters.top_p = 1
                return
            }
            if (num < 0 || num > 1) {
                num = 1
            }
            this.configList[index].parameters.top_p = String(num)
        },
        validateTokens(index) {
            let num = parseInt(this.configList[index].parameters.max_tokens)
            if (isNaN(num)) {
                this.configList[index].parameters.max_tokens = 512
                return
            }
            if (String(num) !== this.configList[index].parameters.max_tokens || (num < 0 || num > 4096)) {
                this.configList[index].parameters.max_tokens = 512
            }
        },
        validateTurns(index) {
            let num = parseInt(this.configList[index].parameters.turns)
            if (isNaN(num)) {
                this.configList[index].parameters.turns = ""
                return
            }
            if (String(num) !== this.configList[index].parameters.turns || (num < 1 || num > 10)) {
                this.configList[index].parameters.turns = ""
            }
        },
        checkValidDelete(index) {
            let toDelete = this.configList[index]
            let nodeUseToDelete = []
            switch (this.configType) {
                case 'llm_classifier':
                    this.nodeUsedConfigs.forEach(item => {
                        if (item.config.llmClassifier.some(configItem => configItem.label === toDelete.label)) {
                            nodeUseToDelete.push(item)
                        }
                    })
                    break;
                case 'llm_response':
                    this.nodeUsedConfigs.forEach(item => {
                        if (item.config.llmResponse.label === toDelete.label) {
                            nodeUseToDelete.push(item)
                        }
                    })
                    break;
                default:

            }
            if (nodeUseToDelete.length > 0) {
                let nodes = nodeUseToDelete.map(node => node.name).join(", ")
                this.$appService.toastError(this.$f.tc("canNotDeleteConfig", {"nodes": nodes}))
                return false
            }
            return true
        },
        insertDefaultSummaryPrompt() {
            this.configList[0].parameters.system_prompt = defaultSummaryPrompt
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.saveLLMSetting()
            } else if (this.$refs.form) {
                this.$refs.form.validate()
                this.$emit('submit-error', new Error('Form validation failed'));
            }
        },
        saveLLMSetting() {
            if (!this.isValidLLMConfig()) {
                this.$appService.toastError(this.$f.tc('pleaseEnterAllFieldsInItem', [this.configTypeText]))
                this.$emit('submit-error', new Error('Form validation failed, invalid LLM Config'));
                return
            }

            let labelConfigUsed = this.getLabelUsed()
            this.configList.forEach(config => {
                config.label = config.label.trim()
            })
            let labelsNotHas = []
            for (let label of labelConfigUsed) {
                if (!this.configList.find(i => i.label === label || i.oldLabel === label) && !labelsNotHas.includes(label)) {
                    labelsNotHas.push(label)
                }
            }
            if (labelsNotHas.length > 0) {
                this.$appService.toastError(
                    `${this.$f.tc('pleaseAddLLMConfigs', [labelsNotHas.join(", ")])}`
                )
                this.$emit('submit-error', new Error('Form validation failed, LLM not has'));
                return
            }
            this.saveLLMConfigs()
        },
        isValidLLMConfig() {
            let isValid = true
            for (let item of this.configList) {
                if (!item.label || !item.llm_config || !item.parameters.system_prompt) {
                    isValid = false
                    item.error = true
                } else {
                    item.error = false
                }
            }
            return isValid
        },
        getLabelUsed() {
            let labelConfigUsed = []

            switch (this.configType) {
                case 'llm_classifier':
                    this.nodeUsedConfigs.forEach(node => {
                        let labels = node.config.llmClassifier.map(i => i.label)
                        labelConfigUsed = [...labelConfigUsed, ...labels]
                    })
                    break;
                case 'llm_response':
                    this.nodeUsedConfigs.forEach(item => {
                        if (item.config.llmResponse && Object.keys(item.config.llmResponse).length > 0) {
                            labelConfigUsed.push(item.config.llmResponse.label)
                        }
                        if (item.config.rePromptList && Object.keys(item.config.rePromptList).length > 0) {
                            let labels = item.config.rePromptList.map(i => i.llmResponse?.label).filter(label => label !== undefined);
                            labelConfigUsed = [...labelConfigUsed, ...labels]
                        }
                    })
                    break;
                default:
            }
            return labelConfigUsed
        },
        saveLLMConfigs() {
            this.updateLabelLLMNodes()

            let {uniqueAdd, updateList, deleteList} = this.getUpdateList()
            this.$emit('getChanges', {uniqueAdd, updateList, deleteList})
            this.$emit('submit')
        },
        updateLabelLLMNodes() {
            let labelLLMsChanged = this.configList.filter(item => item.oldLabel && item.label !== item.oldLabel)
            let labelMap = {}
            labelLLMsChanged.forEach(item => {
                labelMap[item.oldLabel] = item.label
            })
            if (labelLLMsChanged.length > 0) {
                switch (this.configType) {
                    case 'llm_classifier':
                        this.handleUpdateClassifierLabel(labelLLMsChanged, labelMap)
                        break;
                    case 'llm_response':
                        this.handleUpdateResponseLabel(labelLLMsChanged, labelMap)
                        break;
                    default:
                }
            }
        },
        handleUpdateClassifierLabel(labelLLMsChanged, labelMap) {
            let nodes = this.nodeUsedConfigs.filter(node =>
                node.config.llmClassifier.some(llm =>
                    labelLLMsChanged.some(i => i.oldLabel === llm.label)
                )
            );
            nodes.forEach(node => {
                let newConfig = node.config
                newConfig.llmClassifier.forEach(llm => {
                    if (labelMap[llm.label]) {
                        llm.label = labelMap[llm.label];
                    }
                });
                this.$store.dispatch(this.$actionTypes.scenario.UPDATE_NODE, {
                    scenarioId: this.$route.params.scenarioId,
                    id: node.id,
                    model: {
                        config: newConfig
                    }
                })
            });
        },
        handleUpdateResponseLabel(labelLLMsChanged, labelMap) {
            let nodes = this.nodeUsedConfigs.filter(node => {
                const isConfigLabelChanged = labelLLMsChanged.some(item => item.oldLabel === node.config.llmResponse?.label);

                const isRePromptLabelChanged = node.config.rePromptList.some(rePrompt => {
                    return labelLLMsChanged.some(item => item.oldLabel === rePrompt.llmResponse?.label);
                });

                return isConfigLabelChanged || isRePromptLabelChanged;
            });
            nodes.forEach(node => {
                let newConfig = node.config
                // Update the llmResponse.label if it's in the labelMap
                if (labelMap[node.config.llmResponse?.label]) {
                    newConfig.llmResponse.label = labelMap[node.config.llmResponse.label];
                }

                // Update the llmResponse.label in rePromptList if it's in the labelMap
                newConfig.rePromptList.forEach(rePrompt => {
                    if (labelMap[rePrompt.llmResponse?.label]) {
                        rePrompt.llmResponse.label = labelMap[rePrompt.llmResponse.label];
                    }
                });
                this.$store.dispatch(this.$actionTypes.scenario.UPDATE_NODE, {
                    scenarioId: this.$route.params.scenarioId,
                    id: node.id,
                    model: {
                        config: newConfig
                    }
                })
            })
        },
        getUpdateList() {
            let addList = []
            let updateList = []
            let deleteList = []
            for (let item of this.configList) {
                let originalItem = this.originalItemMap[item.id]
                if (originalItem) {
                    originalItem.doNotDelete = true
                    if (
                        item.label !== originalItem.label
                        || item.llm_config !== originalItem.llm_config
                        || item.parameters.include_chat_history !== originalItem.parameters.include_chat_history
                        || item.parameters.max_tokens !== originalItem.parameters.max_tokens
                        || item.parameters.system_prompt !== originalItem.parameters.system_prompt
                        || item.parameters.temperature !== originalItem.parameters.temperature
                        || item.parameters.top_p !== originalItem.parameters.top_p
                        || item.parameters.turns !== originalItem.parameters.turns
                    ) {
                        item.id = originalItem.id
                        updateList.push(item)
                    }
                } else {
                    addList.push(item)
                }
            }

            for (let i in this.originalItemMap) {
                let item = this.originalItemMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }

            let uniqueAdd = []
            let seenLabels = new Set()
            for (const item of addList) {
                const key = `${item.label}-${item.type}`; // create unique combo key
                if (!seenLabels.has(key)) {
                    seenLabels.add(key);
                    uniqueAdd.push(item);
                }
            }

            return {uniqueAdd, updateList, deleteList}
        },
        ruleDuplicateLabel(value) {
            let check = this.configList.filter(i => i.label === value).length <= 1
            return check || this.$f.tc('duplicated')
        },
    },
    watch: {
        config: {
            immediate: true,
            deep: true,
            handler: function () {
                this.loadData()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.config {
    padding: 10px 12px;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
}

.config-padding {
    padding: 10px 12px;
}

.config-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.textarea-custom {
    ::v-deep {
        textarea {
            padding: 8px 12px !important;

            &::-webkit-scrollbar {
                width: 7px;
                height: 10px;
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.1);
                border: none;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(0, 0, 0, 0.5);
            }
        }
    }
}

.textarea-custom, .input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            outline-offset: 0;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}
</style>
